<template>
	<div>
		<div class="pd30">

			<!-- <div class="mt20 ">
				<a-radio-group v-model="search.mendian_id" button-style="solid" @change="changeMendian">
					<a-radio-button :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">
						{{item.name}}
					</a-radio-button>
				</a-radio-group>
			</div> -->

			<div class="form-search-box ">
				<a-form layout="inline">
					<a-form-item label="课程简称">
						<a-input v-model="search.course_name" placeholder="请输入课程简称"></a-input>
					</a-form-item>

					<a-form-item label="课程分类">
						<div>
							<a-select style="width: 120px" placeholder="全部分类" v-model="search.course_type_id">
								<a-select-option :value="0">全部分类</a-select-option>
								<a-select-option :value="item.course_type_id" :key="index" v-for="(item,index) in type_list">{{item.name}}</a-select-option>
							</a-select>
						</div>
					</a-form-item>
					
					<a-form-item label="销量">
						<a-input v-model="search.bg_take_count" style="width: 80px"></a-input>
						-
						<a-input v-model="search.end_take_count" style="width: 80px"></a-input>
					</a-form-item>
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>

			<div  class="mt20">
				<a-button type="primary" icon="plus" @click="addCourseAct()">添加课程</a-button>
				<!-- <a-button type="primary" icon="plus" style="margin-left:20px;" @click="chooseTemplateAct()">通过模板创建项目</a-button> -->
			</div>

			<div class="">
				<div class="wxb-table-gray">
					<a-table rowKey="course_id" :columns="columns" :pagination="pagination" @change="handleTableChange"
						:data-source="datas" :loading="loading">
						
						<div class="flex alcenter center" slot="mendian_slot" slot-scope="mendian_id,record">
							{{record.mendian.name ? record.mendian.name : '暂无'}}
						</div>

						<div class="flex alcenter center" slot="course" slot-scope="record">
							<img :src="record.cover_img"  class="projetc-index-cover-img" />
							<div class="ml5" style="text-align: left;">
								<div>{{record.course_name}}</div>
							</div>
						</div>
						
						<div class="flex alcenter center" slot="type" slot-scope="type,record">
							{{type != null ? type.name : '暂无分类'}}
						</div>
						
						<div class="flex alcenter center" slot="market_price_slot" slot-scope="market_price,record">
							¥{{market_price}}
						</div>

						<div class="flex alcenter center" slot="price_slot" slot-scope="price,record">
							¥{{price}}
						</div>

						<template slot="status_slot" slot-scope="status,record">
							<div v-if="status == 1">正常</div>
							<div v-if="status == 2">失效</div>
						</template>

						<template slot="is_top_slot" slot-scope="is_top,record">
							<div v-if="is_top == 0">否</div>
							<div v-if="is_top == 1">是</div>
						</template>

						<template slot="is_hot_slot" slot-scope="is_hot,record">
							<div v-if="is_hot == 0">否</div>
							<div v-if="is_hot == 1">是</div>
						</template>

						<template slot="is_new_slot" slot-scope="is_new,record">
							<div v-if="is_new == 0">否</div>
							<div v-if="is_new == 1">是</div>
						</template>

						<template slot="action" slot-scope="record,index">
							<div class="flex center">
								<a-dropdown placement="bottomRight">
									<span class="more-act">
										<i class="iconfont iconmore_gray"></i>
									</span>
									<a-menu slot="overlay">
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="editCourseAct(record)">
												<i class="iconfont ft14 iconedit"></i>
												<span class="ml10">编辑</span>
											</a>
										</a-menu-item>
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="delCourseAct(record)">
												<i class="iconfont ft14 icondelete"></i>
												<span class="ml10">删除</span>
											</a>
										</a-menu-item>

									</a-menu>
								</a-dropdown>
							</div>
						</template>
					</a-table>
				</div>
			</div>
		</div>
		<!-- <div v-if="chooseTemplateVisible">
			<choose-template v-model="chooseValue" :visible="chooseTemplateVisible" @cancel="cancelChooseTemplate" @ok="okChooseTemplate"></choose-template>
		</div> -->
	</div>
</template>

<script>
	import {listMixin} from '../../../../common/mixin/list.js';
	// import chooseTemplate from './chooseTemplate.vue';
	export default{
		components:{
			// chooseTemplate,
		},
		mixins: [listMixin],
		data(){
			return{
				template:33,
				loading: false,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				type_list:[],
				search:{
					course_name:'',
					course_type_id:0,
					bg_take_count: '',
					end_take_count: '',
					mendian_id:0
				},
				columns: [
					{title: '课程编号',dataIndex: 'course_id',align: 'center'},
					{title: '课程名称',key: 'course',align: 'center',width:300,scopedSlots: {customRender: 'course'}},
					// {title: '门店',key: 'mendian_id',align: 'center',width:120,scopedSlots: {customRender: 'mendian_slot'}},
					{title: '所属分类',dataIndex: 'type',align: 'center',scopedSlots: {customRender: 'type'}},
					{title: '市场价',dataIndex: 'market_price',align: 'center',scopedSlots: {customRender: 'market_price_slot'}},
					{title: '现价',dataIndex: 'price',align: 'center',scopedSlots: {customRender: 'price_slot'}},
					{title: '库存',dataIndex: 'stock',align: 'center',ellipsis: true},
					{title: '状态',dataIndex: 'status',align: 'center',scopedSlots: {customRender: 'status_slot'}},
					{title: '已售',dataIndex: 'take_count',align: 'center',ellipsis: true},
					{title: '是否置顶',dataIndex: 'is_top',align: 'center',scopedSlots: {customRender: 'is_top_slot'}},
					{title: '是否热门',dataIndex: 'is_hot',align: 'center',scopedSlots: {customRender: 'is_hot_slot'}},
					{title: '是否新品',dataIndex: 'is_new',align: 'center',scopedSlots: {customRender: 'is_new_slot'}},
					{title: '排序',dataIndex: 'sort',align: 'center'},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true,width:160},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
				mendians: [],
				chooseTemplateVisible:false,
				chooseValue:{
					template_id:0
				}
			}
		},
		created() {
			this.getMendians();
		},
		methods:{
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getCourseList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					course_name:this.search.course_name,
					course_type_id:this.search.course_type_id,
					bg_take_count:this.search.bg_take_count,
					end_take_count:this.search.end_take_count,
					mendian_id:this.search.mendian_id,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					if(res.type_list){
						this.type_list=res.type_list;
					}
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
			},
			
			delCourseAct(record){
				this.$confirm({
					title:'确认删除这个课程吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delCourse',{
								course_id:record.course_id,
							}).then(res=>{
								this.$message.success('删除成功',1,()=>{
									this.getLists();
								});
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			addCourseAct(){
				this.$router.push('/course/edit');
			},
			editCourseAct(record){
				this.$router.push('/course/edit?id='+record.course_id);
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			chooseTemplateAct(){
				this.chooseTemplateVisible=true;
			},
			cancelChooseTemplate(){
				this.chooseTemplateVisible=false;
			},
			okChooseTemplate(){
				this.chooseTemplateVisible=false;
				if(this.chooseValue.template_id){
					console.log('选择的模板：',this.chooseValue.template_id)
					this.$router.push('/course/edit?template_id='+this.chooseValue.template_id);
				}
			},
			changeMendian() {
				this.pagination.current = 1;
				this.getLists();
			},
		}
	}
</script>

<style>
	.projetc-index-cover-img{
		width: 80px;
		height: 60px;
	}
</style>
